import { NavigateFunction } from "react-router-dom";
import { fetchNewCenturyHealthQuestionnaire } from "../../../../api/postCall/newCenturyHealthQuestion";
import { logError } from "../../../../utils/customLogger";

export const handleSubmissionForNchPortal = async (
  navigate: NavigateFunction,
  id: string,
  hasQuestions: boolean,
  shouldRunMedicalNeccessity: boolean,
  setLoading: (loading: boolean) => void,
) => {
  if (!hasQuestions || shouldRunMedicalNeccessity) {
    try {
      setLoading(true);
      await fetchNewCenturyHealthQuestionnaire(id, 5);
    } catch (error) {
      logError(
        error as Error,
        "Error fetching New Century Health questionnaire",
      );
    } finally {
      setLoading(false);
      navigate(`/worklists/portal-questionnaire/${id}`);
    }
  } else {
    navigate(`/worklists/portal-questionnaire/${id}`);
  }
};
